export default __webpack_public_path__ + "static/media/feature-1.fc060d75.jpg";